<template>
    <div id="contact-modal">
        <div class="modal fade show" tabindex="-1" aria-modal="true" role="dialog" style="display: block;">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" v-click-outside="closeModal" style="overflow:hidden;">
                    <div class="modal-body">
                        <form class="p-4 p-md-3 rounded-3">
                            <div class="form-floating mb-3">
                                <input v-model="name" type="text" id="name" name="name" class="form-control">
                                <label for="name">Naam</label>
                            </div>
                            <div class="form-floating mb-3">
                                <input v-model="phone" type="tel" id="phone" name="phone" class="form-control">
                                <label for="phone">Telefoonnummer</label>
                            </div>
<!--                            <div class="form-floating mb-3" v-if="type === 'franchise'">-->
<!--                                <input v-model="email" type="tel" id="email" name="phone" class="form-control">-->
<!--                                <label for="phone">Email</label>-->
<!--                            </div>-->
                            <div class="alert alert-success" role="alert" v-if="sendSuccess">
                                <i class="bi bi-check-circle-fill"></i> Gelukt! Tot snel
                            </div>
                            <div class="alert alert-danger" role="alert" v-if="errors.length">
                                <i class="bi bi-x-circle-fill" style="margin-right: 4px;"></i> Whoops
                                <ul class="errors mb-0">
                                    <li v-for="message in errors">{{ message }}</li>
                                </ul>
                            </div>
                            <button @click.prevent="send" class="w-100 btn btn-lg btn-success" type="submit"
                                    style="z-index:2;">
                                <i class="bi bi-chevron-right" style="margin-right: 12px;" v-if="!loading"></i>
                                <span class="spinner-border" role="status" v-if="loading"
                                      style="height: 1rem;
                                        width: 1rem;
                                        vertical-align: 0; margin-right: 12px;">
                                        <span class="visually-hidden">Loading...</span>
                                    </span>
                                Verstuur
                            </button>
                            <!--                                <hr class="my-4">-->
                            <small class="text-muted">
                                <!--                                    <em>Spreek je snel!</em>-->
                                <img src="/images/pg-logo-s.png" alt="Private Gym Beeldmerk" style="    position: absolute;
                                        height: 84px;
                                        float: right;
                                        right: -10px;
                                        bottom: -30px;
                                        z-index:1;
                                        opacity: 0.05;">
                            </small>
                        </form>
                    </div>
                    <!--                    <div class="modal-footer">-->
                    <!--                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show"></div>
    </div>
</template>

<script>

import vClickOutside from "click-outside-vue3";
import axios from "axios";

export default {
    components: {},

    props: ['type'],

    mixins: [],

    data: function () {
        return {
            name: '',
            email: '',
            phone: '',

            sendSuccess: false,
            loading: false,
            errors: [],
        };
    },

    directives: {
        clickOutside: vClickOutside.directive
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        closeModal() {
            this.$emit('closed');
        },
        send() {
            const vm = this;
            this.loading = true;
            this.errors = [];

            axios.post('/contact', {
                name: this.name,
                phone: this.phone,
                // email: this.email,
                type: this.type,
            })
                .then(function (response) {
                    vm.loading = false;
                    vm.sendSuccess = true;
                })
                .catch(function (error) {
                    vm.loading = false;
                    vm.sendSuccess = false;
                    if (typeof error.response.data.errors !== 'undefined') {
                        Object.keys(error.response.data.errors).forEach(formName => {
                            error.response.data.errors[formName].forEach(errorMessage => {
                                vm.errors.push(errorMessage);
                            });
                        })
                    }
                });
        },
    },

    watch: {
        //
    }
};
</script>
<style lang="scss">
#contact-modal {
    ul.errors > li:first-letter {
        text-transform: uppercase;
    }
}
</style>
